import { useLang } from "@/context/LanguageContext";
import { Languages } from "lucide-react";

export function LanguageToggle({ dark = false }) {
    const { lang, toggle } = useLang();
    return (
        <button
            data-testid="language-toggle"
            onClick={toggle}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${dark ? "bg-white/10 text-white hover:bg-white/20" : "border border-navy/15 text-navy hover:border-orange"}`}
        >
            <Languages size={14} />
            {lang === "en" ? "हिंदी" : "English"}
        </button>
    );
}
